import router from '@/router/router.ts'
import { useAuthStore } from '@/stores/auth.store'
import type { RouteLocationAsRelativeGeneric, RouteLocationRaw } from 'vue-router'

export function replaceURLSilent(path: RouteLocationAsRelativeGeneric) {
    window.history.pushState({}, '', router.resolve(path).href)
}

export function isRouteVisible(route: RouteLocationRaw): boolean {
    const resolved = router.resolve(route)
    const userRole = useAuthStore().user?.role?.type

    const requiresAuth = Boolean(resolved.meta.requiresAuth)
    const allowedRoles = resolved.meta.roles as string[] | undefined

    // WHY: Routes that require authentication must not be visible to anonymous users
    if (requiresAuth && !userRole) {
        return false
    }

    // WHY: Role-restricted routes are only visible to users with an allowed role
    if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
        return Boolean(userRole && allowedRoles.includes(userRole))
    }

    // WHY: Public routes without role restrictions are visible to everyone
    return true
}
